export default __webpack_public_path__ + "static/media/no-item-image.fe72f4ab.png";